import { createPortal } from "react-dom";
import { Button } from "@/components/ui/button";

export default function ContactArtistModal({
  isClient,
  activeArtistContact,
  contactMessage,
  isSendingContact,
  onMessageChange,
  onSend,
  onClose,
}) {
  if (!isClient || !activeArtistContact) {
    return null;
  }
  return createPortal(
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4 py-8"
      onClick={onClose}
    >
      <div
        className="panel-strong max-h-[90vh] w-full max-w-lg overflow-auto p-6"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 className="text-lg font-bold tracking-tight text-zinc-900 dark:text-zinc-50">
          Contact {activeArtistContact.name}
        </h2>
        <p className="mt-1 text-sm text-zinc-500 dark:text-zinc-400">
          Tell them about your opportunity. Include details like date, payout, and vibe.
        </p>
        <textarea
          className="mt-4 h-32 w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm text-zinc-900 placeholder-zinc-400 focus:border-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-400/30 dark:border-white/[0.08] dark:bg-white/[0.05] dark:text-zinc-100"
          value={contactMessage}
          onChange={(event) => onMessageChange(event.target.value)}
          placeholder="Hi! We'd love to invite you to..."
        ></textarea>
        <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:justify-end">
          <Button
            type="button"
            className="btn-secondary"
            onClick={onClose}
            disabled={isSendingContact}
          >
            Cancel
          </Button>
          <Button
            type="button"
            className="btn-primary"
            onClick={onSend}
            disabled={isSendingContact}
          >
            {isSendingContact ? "Sending..." : "Send message"}
          </Button>
        </div>
      </div>
    </div>,
    document.body
  );
}
